<template>
  <div class="stbox">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>现患率数据上报</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs style="margin-top: 15px" v-model="activeName">
      <el-tab-pane label="数据上报" name="first">
        <div class="text" style="margin-top: 20px">
          <label>请先从本地选择数据文件，然后点击数据上传按钮提交。
            <label class="texthos">{{ loginUser.HospitalName }} (医疗机构代码:{{
              loginUser.HospitalNumber
            }})
            </label>
          </label>
        </div>
        <div style="margin-top:80px" @click="checkVideo">
          <el-steps :active="3" simple style="margin-top: 20px">
            <el-step title="现患率培训视频"></el-step>
            <el-step title="完善现患率平台医院及科室信息"></el-step>
            <el-step title="上报现患率数据"></el-step>
          </el-steps>
        </div>
        <div class="bottom">
          <el-image class="image" :src="src"></el-image>
          <div class="upload-position">
            <p class="alltext">上传：数据文件要求xml格式</p>
            <el-upload accept=".zip" class="upload-demo" ref="upload"
              :action="uploadFileUrl + 'PrevalenceRate/UploadXhlFile'" :before-upload="beforeUpload"
              :on-success="uploadSuccess" :on-exceed="handleExceed" :file-list="fileList" :auto-upload="false"
              :multiple="false" :limit="1">
              <el-button slot="trigger" type="primary">选择文件</el-button>
              <el-tooltip content="上传时间已过" placement="top">
                <el-button style="margin-left: 10px" type="success" :loading="load" @click="submitUpload"
                  :disabled="true">数据上传</el-button>
              </el-tooltip>
              <!-- <el-button style="margin-left: 10px" type="success" :loading="load" @click="submitUpload">数据上传</el-button> -->
              <div slot="tip" class="el-upload__tip">只能上传xml文件</div>
            </el-upload>
          </div>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="数据浏览/填报" name="second">
        <el-tabs v-model="activeName2">
          <el-tab-pane label="科室设置" name="one"><el-form :inline="true" :model="deptName" class="user-search">
              <el-form-item label="科室名称：">
                <el-input clearable size="small" v-model="deptName" placeholder="输入科室名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" icon="el-icon-search" @click="getDeptData">搜索</el-button>
                <el-button type="primary" size="small" icon="el-icon-plus"
                  @click="add_editDept('add', {})">设置科室</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="deptData.slice((page - 1) * pagesize, page * pagesize)" style="width: 100%">
              <el-table-column prop="OfficeID" label="本院科室编号">
              </el-table-column>
              <el-table-column prop="OfficeName" label="本院科室名称">
              </el-table-column>
              <el-table-column prop="BM" label="本院科室助记码">
              </el-table-column>
              <el-table-column prop="StandardOfficeID" label="标准科室编号">
              </el-table-column>
              <el-table-column prop="StandardOfficeName" label="标准科室名称">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" icon="el-icon-edit"
                    @click="add_editDept('edit', scope.row)">编辑</el-button>
                </template>
</el-table-column>
</el-table>
<el-pagination @current-change="pageChange" :current-page.sync="page" :page-size="pagesize"
  layout="prev, pager, next, jumper" :total="deptData.length">
</el-pagination>
</el-tab-pane>
<el-tab-pane label="个案登记表" name="two">
  <el-form :inline="true" :model="patient" class="user-search">
    <el-form-item label="患者姓名：">
      <el-input clearable size="small" v-model="patient.name" placeholder="输入患者姓名"></el-input>
    </el-form-item>
    <el-form-item label="患者编号：">
      <el-input clearable size="small" v-model="patient.number" placeholder="输入患者编号"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="small" icon="el-icon-search" @click="getPatientData">搜索</el-button>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addDrawer = true">填报数据</el-button>
    </el-form-item>
  </el-form>
  <el-table :data="patientData.slice((page - 1) * pagesize, page * pagesize)" style="width: 100%">
    <el-table-column prop="date" label="日期" width="180">
    </el-table-column>
    <el-table-column prop="name" label="姓名" width="180">
    </el-table-column>
    <el-table-column prop="address" label="地址"> </el-table-column>
  </el-table>
  <el-pagination @current-change="pageChange" :current-page.sync="page" :page-size="pagesize"
    layout="prev, pager, next, jumper" :total="patientData.length">
  </el-pagination>
</el-tab-pane>
<el-tab-pane label="床旁调查表" name="three"> </el-tab-pane>
<el-tab-pane label="执行登记表" name="four"> </el-tab-pane>
</el-tabs>
</el-tab-pane>
<el-tab-pane label="数据统计" name="third"> </el-tab-pane> -->
    </el-tabs>
    <el-drawer :visible.sync="addDept" direction="rtl" :with-header="false" :before-close="handleClose">
      <el-form ref="form" :model="deptForm" label-width="240px" style="margin-top:100px">
        <el-form-item label="本院科室编号">
          <el-input clearable style="width: 200px" size="small" v-model="deptForm.OfficeID"></el-input>
        </el-form-item>
        <el-form-item label="本院科室名称">
          <el-input clearable style="width: 200px" size="small" v-model="deptForm.OfficeName"></el-input>
        </el-form-item>
        <el-form-item label="对应标准科室">
          <el-select clearable style="width: 200px" size="small" v-model="deptForm.StandardOfficeName" filterable
            placeholder="请选择科室">
            <el-option v-for="item in allDept" :key="item.ID" :label="item.StandardOfficeName"
              :value="item.ID + '-' + item.StandardOfficeName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="助记符">
          <el-input clearable style="width: 200px" size="small" v-model="deptForm.BM"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSubmit">提交</el-button>
          <el-button size="small" @click="handleClose(false)">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer :visible.sync="addDrawer" direction="ttb" :before-close="handleClose" :with-header="false" size="90%">
      <div class="title">
        <label>2025年医院感染现患率调查个案登记表</label>
      </div>
      <div>
        <p style="margin-left: 260px">一、一般情况</p>
        <div class="body">
          <p>
            <label>
              患者编号:<el-input style="width: 200px" clearable size="small" v-model="PatientsInfo.PatientNumber"
                placeholder="输入患者编号"></el-input>
            </label>
            <label style="margin-left: 20px">
              科室:<el-select clearable style="width: 200px" size="small" v-model="PatientsInfo.StandardOffice" filterable
                placeholder="请选择科室">
                <el-option v-for="item in deptData" :key="item.OfficeName" :label="item.OfficeName"
                  :value="item.OfficeName">
                </el-option>
              </el-select>
            </label>
            <label style="margin-left: 20px">
              床号:<el-input style="width: 200px" clearable size="small" v-model="PatientsInfo.BedNumber"
                placeholder="输入床号"></el-input>
            </label>
            <label style="margin-left: 20px">
              病历号:<el-input style="width: 200px" clearable size="small" v-model="PatientsInfo.InHospitalNumber"
                placeholder="输入病历号"></el-input>
            </label>
            <label style="margin-left: 20px">
              姓名:<el-input style="width: 200px" clearable size="small" v-model="PatientsInfo.Name"
                placeholder="输入姓名"></el-input>
            </label>
          </p>
          <p>
            <label>
              性别:<el-radio v-model="PatientsInfo.Sex" label="男">男</el-radio>
              <el-radio v-model="PatientsInfo.Sex" label="女">女</el-radio>
            </label>
            <label style="margin-left: 20px">
              年龄:<el-input-number v-model="PatientsInfo.PatientYear" :min="0" :max="150" style="width: 10%"
                size="small" />岁<el-input-number v-model="PatientsInfo.PatientMonth" :min="0" :max="11"
                style="width: 10%" size="small" />月<el-input-number v-model="PatientsInfo.PatientDay" :min="0" :max="31"
                style="width: 10%" size="small" />天
            </label>
            <label style="margin-left: 20px">
              入院日期:<el-date-picker style="width: 200px" clearable size="small" v-model="InHospitalDate" type="datetime"
                placeholder="请选择入院日期"></el-date-picker>
            </label>
          </p>
          <p>
            <label>
              诊断:<el-input type="textarea" size="small" style="width:60%" v-model="PatientsInfo.ClinicalDiagnosis1"
                placeholder="请输入诊断"></el-input>
            </label>
          </p>
          <p>
            <label>
              本次住院是否手术:<el-radio v-model="PatientsInfo.IsSurgery" label="是">是</el-radio>
              <el-radio v-model="PatientsInfo.IsSurgery" label="否">否</el-radio>
            </label>
            <label style="margin-left: 20px">
              手术切口类型:<el-radio v-model="PatientsInfo.IncisionType" label="I类">I类</el-radio>
              <el-radio v-model="PatientsInfo.IncisionType" label="II类">II类</el-radio>
              <el-radio v-model="PatientsInfo.IncisionType" label="III类">III类</el-radio>
              <el-radio v-model="PatientsInfo.IncisionType" label="IV类">IV类</el-radio>
            </label>
            <label style="margin-left: 20px">
              I类切口手术类型:<el-radio v-model="PatientsInfo.SurgeryType" label="脑出血手术">脑出血手术</el-radio>
              <el-radio v-model="PatientsInfo.SurgeryType" label="髋关节置换术">髋关节置换术</el-radio>
              <el-radio v-model="PatientsInfo.SurgeryType" label="膝关节置换术">膝关节置换术</el-radio>
              <el-radio v-model="PatientsInfo.SurgeryType" label="其他">其他</el-radio>
            </label>
          </p>
          <p>
            <label>
              本次住院是否存在手术部位感染:<el-radio v-model="HospitalInfection.ssbwgr" label="是">是</el-radio>
              <el-radio v-model="HospitalInfection.ssbwgr" label="否">否</el-radio>
            </label>
            <label style="margin-left: 20px">
              手术部位感染类型:<el-radio v-model="HospitalInfection.ssbwgrlx" label="表浅手术切口感染">表浅手术切口感染</el-radio>
              <el-radio v-model="HospitalInfection.ssbwgrlx" label="深部手术切口感染">深部手术切口感染</el-radio>
              <el-radio v-model="HospitalInfection.ssbwgrlx" label="器官（或腔隙）感染">器官（或腔隙）感染</el-radio>
            </label>
            <label style="margin-left: 20px">
              本调查日是否存在手术后肺炎:<el-radio v-model="PatientsInfo.IsSurgeryFY" label="存在">存在</el-radio>
              <el-radio v-model="PatientsInfo.IsSurgeryFY" label="不存在">不存在</el-radio>
            </label>
          </p>
        </div>
        <p style="margin-left: 260px">
          二、调查当日感染情况（包括医院感染与社区感染）
        </p>
        <div class="body">
          <p>
            <label>
              感染:<el-radio v-model="HospitalInfection.HasInfection" label="存在">存在</el-radio>
              <el-radio v-model="HospitalInfection.HasInfection" label="不存在">不存在</el-radio>
            </label>
            <label style="margin-left: 20px">
              感染分类:<el-checkbox v-model="HospitalInfection.IsHospitalInfection">医院感染</el-checkbox>
              <el-checkbox v-model="HospitalInfection.IsCommunityInfection">社区感染</el-checkbox>
            </label>
            <label style="margin-left: 20px">
              首次医院感染日期:<el-date-picker style="width: 200px" clearable size="small"
                v-model="HospitalInfection.BeginInfectDate" type="datetime" placeholder="请选择感染日期"></el-date-picker>
            </label>
          </p>
          <p>
            <label>
              医院感染部位:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[0].InfectionPsitions.PartName" filterable
                placeholder="请选择医院感染部位">
                <el-option v-for="item in allPart" :key="item.PartName" :label="item.PartName" :value="item.PartName">
                </el-option>
              </el-select>
              病原体:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[0].InfectionPsitions.Pathogens1" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[0].InfectionPsitions.Pathogens2" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[0].InfectionPsitions.Pathogens3" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
            </label>
          </p>
          <p>
            <label>
              医院感染部位:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[1].InfectionPsitions.PartName" filterable
                placeholder="请选择医院感染部位">
                <el-option v-for="item in allPart" :key="item.PartName" :label="item.PartName" :value="item.PartName">
                </el-option>
              </el-select>
              病原体:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[1].InfectionPsitions.Pathogens1" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[1].InfectionPsitions.Pathogens2" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[1].InfectionPsitions.Pathogens3" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
            </label>
          </p>
          <p>
            <label>
              医院感染部位:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[2].InfectionPsitions.PartName" filterable
                placeholder="请选择医院感染部位">
                <el-option v-for="item in allPart" :key="item.PartName" :label="item.PartName" :value="item.PartName">
                </el-option>
              </el-select>
              病原体:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[2].InfectionPsitions.Pathogens1" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[2].InfectionPsitions.Pathogens2" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.HospitalInfectionPsitions[2].InfectionPsitions.Pathogens3" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
            </label>
          </p>
          <p>
            <label>
              社区感染部位:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[0].InfectionPsitions.PartName" filterable
                placeholder="请选择社区感染部位">
                <el-option v-for="item in allPart" :key="item.PartName" :label="item.PartName" :value="item.PartName">
                </el-option>
              </el-select>
              病原体:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[0].InfectionPsitions.Pathogens1" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[0].InfectionPsitions.Pathogens2" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[0].InfectionPsitions.Pathogens3" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
            </label>
          </p>
          <p>
            <label>
              社区感染部位:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[1].InfectionPsitions.PartName" filterable
                placeholder="请选择社区感染部位">
                <el-option v-for="item in allPart" :key="item.PartName" :label="item.PartName" :value="item.PartName">
                </el-option>
              </el-select>
              病原体:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[1].InfectionPsitions.Pathogens1" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[1].InfectionPsitions.Pathogens2" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[1].InfectionPsitions.Pathogens3" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
            </label>
          </p>
          <p>
            <label>
              社区感染部位:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[2].InfectionPsitions.PartName" filterable
                placeholder="请选择社区感染部位">
                <el-option v-for="item in allPart" :key="item.PartName" :label="item.PartName" :value="item.PartName">
                </el-option>
              </el-select>
              病原体:<el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[2].InfectionPsitions.Pathogens1" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[2].InfectionPsitions.Pathogens2" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
              <el-select clearable style="width: 200px" size="small"
                v-model="HospitalInfection.CommunityInfectionPsitions[2].InfectionPsitions.Pathogens3" filterable
                placeholder="请选择病原体">
                <el-option v-for="item in allPathogen" :key="item.PathoName" :label="item.PathoName"
                  :value="item.PathoName">
                </el-option>
              </el-select>
            </label>
          </p>
        </div>
        <p style="margin-left: 260px">三、调查当日抗菌药物使用情况</p>
        <div class="body">
          <p>
            <label>
              抗菌药物使用:<el-radio v-model="UseAntibacterialDrug.IsUse" label="是">是</el-radio>
              <el-radio v-model="UseAntibacterialDrug.IsUse" label="否">否</el-radio>
            </label>
            <label style="margin-left: 20px">
              目的:<el-radio v-model="UseAntibacterialDrug.UsePurpose" label="治疗用药">治疗用药</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UsePurpose" label="预防用药">预防用药</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UsePurpose" label="治疗+预防">治疗+预防</el-radio>
            </label>
            <label style="margin-left: 20px">
              联用:<el-radio v-model="UseAntibacterialDrug.UNIONUse" label="一联">一联</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UNIONUse" label="二联">二联</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UNIONUse" label="三联">三联</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UNIONUse" label="四联及以上">四联及以上</el-radio>
            </label>
          </p>
          <p>
            <label>
              治疗用药已送细菌培养:<el-radio v-model="UseAntibacterialDrug.DrugTreatmentInCultivation" label="是">是</el-radio>
              <el-radio v-model="UseAntibacterialDrug.DrugTreatmentInCultivation" label="否">否</el-radio>
            </label>
            <label style="margin-left: 20px">
              其中送培养时机为抗菌药物使用前:<el-radio v-model="UseAntibacterialDrug.DrugTreatmentInCultivationBegin"
                label="是">是</el-radio>
              <el-radio v-model="UseAntibacterialDrug.DrugTreatmentInCultivationBegin" label="否">否</el-radio>
            </label>
          </p>
        </div>
        <p style="margin-left: 260px">四、本次住院细菌耐药情况（填写首次检测结果）</p>
        <div class="body">
          <p>
            <label>
              <label>金黄色葡萄球菌:</label>
              <label style="margin-left:100px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.金黄色葡萄球菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.金黄色葡萄球菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                苯唑西林:
              </label>
              <el-radio v-model="ResistantInfoList.金黄色葡萄球菌.苯唑西林.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.金黄色葡萄球菌.苯唑西林.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.金黄色葡萄球菌.苯唑西林.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                头孢西丁:
              </label>
              <el-radio v-model="ResistantInfoList.金黄色葡萄球菌.头孢西丁.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.金黄色葡萄球菌.头孢西丁.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.金黄色葡萄球菌.头孢西丁.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label>
              <label>凝固酶阴性葡萄球菌:</label>
              <label style="margin-left:68px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.凝固酶阴性葡萄球菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.凝固酶阴性葡萄球菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                苯唑西林:
              </label>
              <el-radio v-model="ResistantInfoList.凝固酶阴性葡萄球菌.苯唑西林.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.凝固酶阴性葡萄球菌.苯唑西林.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.凝固酶阴性葡萄球菌.苯唑西林.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                头孢西丁:
              </label>
              <el-radio v-model="ResistantInfoList.凝固酶阴性葡萄球菌.头孢西丁.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.凝固酶阴性葡萄球菌.头孢西丁.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.凝固酶阴性葡萄球菌.头孢西丁.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label>
              <label>粪肠球菌:</label>
              <label style="margin-left:148px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.粪肠球菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.粪肠球菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                氨苄西林:
              </label>
              <el-radio v-model="ResistantInfoList.粪肠球菌.氨苄西林.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.粪肠球菌.氨苄西林.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.粪肠球菌.氨苄西林.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                万古霉素:
              </label>
              <el-radio v-model="ResistantInfoList.粪肠球菌.万古霉素.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.粪肠球菌.万古霉素.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.粪肠球菌.万古霉素.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label>
              <label>屎肠球菌:</label>
              <label style="margin-left:148px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.屎肠球菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.屎肠球菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                氨苄西林:
              </label>
              <el-radio v-model="ResistantInfoList.屎肠球菌.氨苄西林.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.屎肠球菌.氨苄西林.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.屎肠球菌.氨苄西林.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                万古霉素:
              </label>
              <el-radio v-model="ResistantInfoList.屎肠球菌.万古霉素.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.屎肠球菌.万古霉素.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.屎肠球菌.万古霉素.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label>
              <label>肺炎链球菌:</label>
              <label style="margin-left:132px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.肺炎链球菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎链球菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                青霉素:
              </label>
              <el-radio v-model="ResistantInfoList.肺炎链球菌.青霉素.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎链球菌.青霉素.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎链球菌.青霉素.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label>
              <label>大肠埃希菌:</label>
              <label style="margin-left:132px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                头孢他啶:
              </label>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.头孢他啶.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.头孢他啶.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.头孢他啶.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                亚胺/美罗培南:
              </label>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.亚胺_美罗培南.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.亚胺_美罗培南.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.亚胺_美罗培南.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                左氧氟沙星:
              </label>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.左氧氟沙星.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.左氧氟沙星.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.大肠埃希菌.左氧氟沙星.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label>
              <label>肺炎克雷伯菌:</label>
              <label style="margin-left:115px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                头孢他啶:
              </label>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.头孢他啶.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.头孢他啶.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.头孢他啶.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                亚胺/美罗培南:
              </label>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.亚胺_美罗培南.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.亚胺_美罗培南.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.亚胺_美罗培南.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                左氧氟沙星:
              </label>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.左氧氟沙星.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.左氧氟沙星.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.肺炎克雷伯菌.左氧氟沙星.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label>
              <label>铜绿假单胞菌:</label>
              <label style="margin-left:115px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                环丙沙星:
              </label>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.环丙沙星.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.环丙沙星.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.环丙沙星.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                哌拉西林/他唑巴坦:
              </label>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.哌拉西林_他唑巴坦.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.哌拉西林_他唑巴坦.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.哌拉西林_他唑巴坦.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                亚胺培南:
              </label>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.亚胺培南.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.亚胺培南.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.铜绿假单胞菌.亚胺培南.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label style="margin-left:220px">
              头孢他啶:
            </label>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.头孢他啶.ResistantResult" label="耐药">耐药</el-radio>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.头孢他啶.ResistantResult" label="敏感">敏感</el-radio>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.头孢他啶.ResistantResult" label="未做">未做</el-radio>
            <label style="margin-left:20px">
              头孢吡肟:
            </label>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.头孢吡肟.ResistantResult" label="耐药">耐药</el-radio>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.头孢吡肟.ResistantResult" label="敏感">敏感</el-radio>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.头孢吡肟.ResistantResult" label="未做">未做</el-radio>
            <label style="margin-left:20px">
              阿米卡星:
            </label>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.阿米卡星.ResistantResult" label="耐药">耐药</el-radio>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.阿米卡星.ResistantResult" label="敏感">敏感</el-radio>
            <el-radio v-model="ResistantInfoList.铜绿假单胞菌.阿米卡星.ResistantResult" label="未做">未做</el-radio>
          </p>
          <p>
            <label>
              <label>鲍曼不动杆菌:</label>
              <label style="margin-left:115px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.鲍曼不动杆菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.鲍曼不动杆菌.感染状态.ResistantResult" label="定植">定植</el-radio>
              <label style="margin-left:20px">
                亚胺培南/美罗培南:
              </label>
              <el-radio v-model="ResistantInfoList.鲍曼不动杆菌.亚胺培南_美罗培南.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.鲍曼不动杆菌.亚胺培南_美罗培南.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.鲍曼不动杆菌.亚胺培南_美罗培南.ResistantResult" label="未做">未做</el-radio>
              <label style="margin-left:20px">
                头孢哌酮/舒巴坦:
              </label>
              <el-radio v-model="ResistantInfoList.鲍曼不动杆菌.头孢哌酮_舒巴坦.ResistantResult" label="耐药">耐药</el-radio>
              <el-radio v-model="ResistantInfoList.鲍曼不动杆菌.头孢哌酮_舒巴坦.ResistantResult" label="敏感">敏感</el-radio>
              <el-radio v-model="ResistantInfoList.鲍曼不动杆菌.头孢哌酮_舒巴坦.ResistantResult" label="未做">未做</el-radio>
            </label>
          </p>
          <p>
            <label>
              <label>艰难梭菌:</label>
              <label style="margin-left:148px">
                感染状态:
              </label>
              <el-radio v-model="ResistantInfoList.艰难梭菌.感染状态.ResistantResult" label="感染">感染</el-radio>
              <el-radio v-model="ResistantInfoList.艰难梭菌.感染状态.ResistantResult" label="定植">定植</el-radio>
            </label>
          </p>
        </div>
        <p style="margin-left: 260px">五、患者自入院至调查日是否存在抗菌药物使用升级和（或）抗菌药物等级升级</p>
        <div class="body">
          <p>
            <label>
              患者自入院至调查日是否存在抗菌药物使用升级和（或）抗菌药物等级升级:
              <el-radio v-model="UseAntibacterialDrug.IsUp" label="否">否</el-radio>
              <el-radio v-model="UseAntibacterialDrug.IsUp" label="抗菌药物使用升级">抗菌药物使用升级</el-radio>
              <el-radio v-model="UseAntibacterialDrug.IsUp" label="抗菌药物等级升级">抗菌药物等级升级</el-radio>
              <el-radio v-model="UseAntibacterialDrug.IsUp" label="抗菌药物使用升级且等级升级">抗菌药物使用升级且等级升级</el-radio>
            </label>
          </p>
          <p>
            <label>
              最近一次抗菌药物使用升级和（或）等级升级的原因:
              <el-radio v-model="UseAntibacterialDrug.UpReason" label="预防用药">预防用药</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UpReason" label="患者原有社区感染加重">患者原有社区感染加重</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UpReason" label="患者原有医院感染加重">患者原有医院感染加重</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UpReason" label="患者新发医院感染">患者新发医院感染</el-radio>
              <el-radio v-model="UseAntibacterialDrug.UpReason" label="其他原因">其他原因</el-radio>
              <el-input size="small" style="width:200px" clearable v-model="UseAntibacterialDrug.OtherReason"
                placeholder="请具体说明其他原因"></el-input>
            </label>
          </p>
        </div>
        <div class="body">
          <p>调查者:<el-input style="width: 200px;" clearable size="small" v-model="InvestigateUser"
              placeholder="输入调查者姓名"></el-input>
            调查日期: <el-date-picker style="width: 200px;" clearable size="small" v-model="InvestigateDate" type="datetime"
              placeholder="请选择调查日期"></el-date-picker>
          </p>
        </div>
        <div class="footer">
          <el-button type="primary" style="width: 30%" @click="addPatientData">保存</el-button>
          <el-button style="width: 15%" @click="handleClose(false)">取消</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/ecmascript-6">
import ProgressBar from '../../components/progressBar.vue';
import { readXhlFile } from "../../api/upload";
import {
  hospitalVerification, getPersonCaseTableByGuid,
  savePersonCaseTable, getDeptData,
  addDeptData, editDeptData
} from "../../api/prevalenceRate";
const { create } = require('xmlbuilder');
export default {
  components: { ProgressBar },
  data() {
    return {
      uploadFileUrl: "",
      fileList: [],
      load: false,
      loginUser: {},
      hospitalNumber: "",
      hospitalName: "",
      activeName: "first",
      activeName2: 'one',
      src: "../static/XML.png",
      allData: [],
      allDept: [],
      deptName: '',
      addDept: false,
      deptForm: {
        OfficeID: '',
        OfficeName: '',
        StandardOfficeID: '',
        StandardOfficeName: '',
        BM: '',
        ID: '',
        HospitalNumber: ''
      },
      deptData: [],
      patient: {
        name: '',
        number: '',
      },
      addDrawer: false,
      patientData: [],
      page: 1,
      pagesize: 15,
      PatientsInfo: {
        BedNumber: '',
        ClinicalDiagnosis1: '',
        HospitalNumber: '',
        InHospitalNumber: '',
        IncisionType: '',
        SurgeryType: '',
        IsSurgery: '',
        IsSurgeryFY: '',
        Name: '',
        PatientDay: 0,
        PatientMonth: 0,
        PatientNumber: '',
        PatientYear: 0,
        Sex: '男',
        StandardOffice: ''
      },
      HospitalInfection: {
        BeginInfectDate: '',
        CommunityInfectionPsitions: [{
          InfectionPsitions: {
            PartName: '',
            Pathogens1: '',
            Pathogens2: '',
            Pathogens3: ''
          },
        }, {
          InfectionPsitions: {
            PartName: '',
            Pathogens1: '',
            Pathogens2: '',
            Pathogens3: ''
          },
        }, {
          InfectionPsitions: {
            PartName: '',
            Pathogens1: '',
            Pathogens2: '',
            Pathogens3: ''
          },
        }],
        HasInfection: '',
        HospitalInfectionPsitions: [{
          InfectionPsitions: {
            PartName: '',
            Pathogens1: '',
            Pathogens2: '',
            Pathogens3: ''
          },
        }, {
          InfectionPsitions: {
            PartName: '',
            Pathogens1: '',
            Pathogens2: '',
            Pathogens3: ''
          },
        }, {
          InfectionPsitions: {
            PartName: '',
            Pathogens1: '',
            Pathogens2: '',
            Pathogens3: ''
          },
        }],
        IsCommunityInfection: '',
        IsHospitalInfection: '',
        ssbwgr: '',
        ssbwgrlx: ''
      },
      ResistantInfoList: {
        金黄色葡萄球菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          苯唑西林: {
            ResistantResult: '未做'
          },
          头孢西丁: {
            ResistantResult: '未做'
          }
        },
        凝固酶阴性葡萄球菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          苯唑西林: {
            ResistantResult: '未做'
          },
          头孢西丁: {
            ResistantResult: '未做'
          }
        },
        屎肠球菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          氨苄西林: {
            ResistantResult: '未做'
          },
          万古霉素: {
            ResistantResult: '未做'
          }
        },
        粪肠球菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          氨苄西林: {
            ResistantResult: '未做'
          },
          万古霉素: {
            ResistantResult: '未做'
          }
        },
        肺炎链球菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          青霉素: {
            ResistantResult: '未做'
          }
        },
        大肠埃希菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          亚胺_美罗培南: {
            ResistantResult: '未做'
          },
          头孢他啶: {
            ResistantResult: '未做'
          },
          左氧氟沙星: {
            ResistantResult: '未做'
          }
        },
        肺炎克雷伯菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          亚胺_美罗培南: {
            ResistantResult: '未做'
          },
          头孢他啶: {
            ResistantResult: '未做'
          },
          左氧氟沙星: {
            ResistantResult: '未做'
          }
        },
        铜绿假单胞菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          阿米卡星: {
            ResistantResult: '未做'
          },
          环丙沙星: {
            ResistantResult: '未做'
          },
          哌拉西林_他唑巴坦: {
            ResistantResult: '未做'
          },
          头孢吡肟: {
            ResistantResult: '未做'
          },
          头孢他啶: {
            ResistantResult: '未做'
          },
          亚胺培南: {
            ResistantResult: '未做'
          }
        },
        鲍曼不动杆菌: {
          感染状态: {
            ResistantResult: '未做'
          },
          头孢哌酮_舒巴坦: {
            ResistantResult: '未做'
          },
          亚胺培南_美罗培南: {
            ResistantResult: '未做'
          }
        },
        艰难梭菌: {
          感染状态: {
            ResistantResult: '未做'
          }
        },
      },
      UseAntibacterialDrug: {
        DrugTreatmentInCultivation: '',
        DrugTreatmentInCultivationBegin: '',
        IsUp: '',
        IsUse: '',
        OtherReason: '',
        UNIONUse: '',
        UpReason: '',
        UsePurpose: '',
      },
      InHospitalDate: '',
      InvestigateUser: '',
      InvestigateDate: '',
      allPart: [],
      allPathogen: [],
      status: '',
    };
  },
  mounted() {
    this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0]
    this.hospitalName = this.loginUser.HospitalName
    this.hospitalNumber = this.loginUser.HospitalNumber
    this.uploadFileUrl = sessionStorage.getItem("baseURL")
    // this.getData()
  },
  methods: {
    getData() {
      this.getDeptData()
      this.getPatientData()
    },
    onSubmit() {
      if (this.status == 'add') {
        this.deptForm.StandardOfficeID = this.deptForm.StandardOfficeName.split('-')[0]
        this.deptForm.StandardOfficeName = this.deptForm.StandardOfficeName.split('-')[1]
        this.deptForm.HospitalNumber = this.hospitalNumber
        addDeptData(this.deptForm).then((res) => {
          if (res.data > 0) {
            this.$message.success(res.msg)
            this.addDept = false
            this.getDeptData()
          }
        });
      }
      if (this.status == 'edit') {
        this.deptForm.StandardOfficeID = this.deptForm.StandardOfficeName.split('-')[0]
        this.deptForm.StandardOfficeName = this.deptForm.StandardOfficeName.split('-')[1]
        editDeptData(this.deptForm).then((res) => {
          if (res.data > 0) {
            this.$message.success(res.msg)
            this.addDept = false
            this.getDeptData()
          }
        });
      }
    },
    add_editDept(ztype, row) {
      this.addDept = true
      this.status = ztype
      if (this.status == 'edit') {
        this.deptForm = row
      }
    },
    getDeptData() {
      getDeptData({
        hCode: this.hospitalNumber,
        deptName: this.deptName
      }).then((res) => {
        this.allDept = res.allDept
        this.deptData = res.deptData
        this.allPart = res.grbw
        this.allPathogen = res.byt
      });
    },
    addPatientData() {
      console.log(this.PatientsInfo,
        this.HospitalInfection,
        this.ResistantInfoList,
        this.UseAntibacterialDrug,
        this.InHospitalDate,
        this.InvestigateUser,
        this.InvestigateDate)
    },
    getPatientData() { },
    handleExceed(files) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`
      );
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["xml"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.warning("只能上传xml文件");
        this.load = false;
        return false;
      }
    },
    submitUpload() {
      if (!this.$refs.upload.uploadFiles.length) {
        this.$message.warning("请选择文件");
        this.load = false;
        return;
      }
      hospitalVerification({
        hospitalCode: this.loginUser.HospitalNumber,
      }).then((res) => {
        if (res.status === "ok") {
          if (!res.data[0].hospitalNumberOfBed || res.data2.length < 1) {
            this.$message.warning("现患率平台医院或科室信息不完整,请填写完整后上传");
            return;
          }
          this.$refs.upload.submit();
          this.load = true;
        } else {
          this.$refs.upload.clearFiles();
          this.load = false;
        }
      });
    },
    uploadSuccess(response) {
      if (response.status == "error") {
        this.$message.warning(response.msg);
        this.$refs.upload.clearFiles();
        this.load = false;
      } else {
        this.$message.success(response.msg + ",正在读取文件内容");
      }
      readXhlFile({
        hCode: this.loginUser.HospitalNumber,
        filePath: response.zipPath
      }).then((res) => {
        if (res.status === "ok") {
          this.allData = res.allData
          this.$message.success(res.msg);
          this.uploadData();
        } else {
          this.$alert(res, '数据验证', {
            confirmButtonText: '确定',
          });
          this.$refs.upload.clearFiles();
          this.load = false;
        }
      });
    },
    async uploadData() {
      var allPersonCaseTableData = []
      let wtxm = ""
      // if (!JSON.stringify(this.allData).includes('PatientInfoList')) {
      //   this.$alert('xml文件内容格式不正确,请修改后上传,首页可下载现患率数据上传xml模板', '提示', {
      //     confirmButtonText: '确定',
      //   });
      //   this.load = false;
      //   this.$refs.upload.clearFiles();
      //   return
      // }
      for (let i = 0; i < this.allData.length; i++) {
        if (this.allData[i].HospitalInfection.HospitalInfectionPsitions.length < 1) {
          wtxm += this.allData[i].PatientsInfo.Name + ","
        } else {
          var params = {
            guid: 'res.data',
            hospitalNumber: this.loginUser.HospitalNumber,
            patientNumber: this.allData[i].PatientsInfo.PatientNumber,
            patientName: this.allData[i].PatientsInfo.Name,
            standardOffice: this.allData[i].PatientsInfo.StandardOffice,
            isInfection: this.allData[i].HospitalInfection.HasInfection == "true" ? "是" : "否",
            hospitalInfectionPart: this.allData[i].HospitalInfection.HospitalInfectionPsitions[0].InfectionPsitions.PartName + '|' +
              this.allData[i].HospitalInfection.HospitalInfectionPsitions[1].InfectionPsitions.PartName + '|' +
              this.allData[i].HospitalInfection.HospitalInfectionPsitions[2].InfectionPsitions.PartName,
            communityInfectionPart: this.allData[i].HospitalInfection.CommunityInfectionPsitions[0].InfectionPsitions.PartName + '|' +
              this.allData[i].HospitalInfection.CommunityInfectionPsitions[1].InfectionPsitions.PartName + '|' +
              this.allData[i].HospitalInfection.CommunityInfectionPsitions[2].InfectionPsitions.PartName,
            data: '<DomainBase xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="PersonCaseMaster">' +
              this.generateXML(this.allData[i]).replace('<?xml version=\"1.0\"?>', '') + '</DomainBase>',
            isUpload: 'true'
          }
          allPersonCaseTableData.push(params)
        }
      }
      if (wtxm != "") {
        this.$alert(wtxm.substring(0, wtxm.length - 1) + ':xml文件中感染部位节点缺失,请完善后重新上传', '提示', {
          confirmButtonText: '确定',
        });
        this.load = false;
        this.$refs.upload.clearFiles();
        return
      }
      savePersonCaseTable({ allData: allPersonCaseTableData }).then((res) => {
        this.$refs.upload.clearFiles();
        this.$alert('数据上传成功，共上传' + allPersonCaseTableData.length + '条数据,如xml中存在重复数据会自动覆盖,实际数据量会减少', '提示', {
          confirmButtonText: '确定',
        });
        this.load = false;
        this.$refs.upload.clearFiles();
      });
    },
    generateXML(data) {
      const xmlStr = create(data).end({ pretty: true });
      return xmlStr;
    },
    generateGUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    pageChange(page) {
      this.page = page;
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.deptForm = {
            OfficeID: '',
            OfficeName: '',
            StandardOfficeID: '',
            StandardOfficeName: '',
            BM: '',
            ID: '',
            HospitalNumber: '',
          }
          this.PatientsInfo = {
            BedNumber: '',
            ClinicalDiagnosis1: '',
            HospitalNumber: '',
            InHospitalNumber: '',
            IncisionType: '',
            IsSurgery: '',
            IsSurgeryFY: '',
            Name: '',
            PatientDay: 0,
            PatientMonth: 0,
            PatientNumber: '',
            PatientYear: 0,
            Sex: '男',
            StandardOffice: ''
          }
          this.HospitalInfection = {
            BeginInfectDate: '',
            CommunityInfectionPsitions: [{
              InfectionPsitions: {
                PartName: '',
                Pathogens1: '',
                Pathogens2: '',
                Pathogens3: ''
              },
            }, {
              InfectionPsitions: {
                PartName: '',
                Pathogens1: '',
                Pathogens2: '',
                Pathogens3: ''
              },
            }, {
              InfectionPsitions: {
                PartName: '',
                Pathogens1: '',
                Pathogens2: '',
                Pathogens3: ''
              },
            }],
            HasInfection: '',
            HospitalInfectionPsitions: [{
              InfectionPsitions: {
                PartName: '',
                Pathogens1: '',
                Pathogens2: '',
                Pathogens3: ''
              },
            }, {
              InfectionPsitions: {
                PartName: '',
                Pathogens1: '',
                Pathogens2: '',
                Pathogens3: ''
              },
            }, {
              InfectionPsitions: {
                PartName: '',
                Pathogens1: '',
                Pathogens2: '',
                Pathogens3: ''
              },
            }],
            IsCommunityInfection: '',
            IsHospitalInfection: '',
            ssbwgr: '',
            ssbwgrlx: ''
          }
          this.ResistantInfoList = {
            金黄色葡萄球菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              苯唑西林: {
                ResistantResult: '未做'
              },
              头孢西丁: {
                ResistantResult: '未做'
              }
            },
            凝固酶阴性葡萄球菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              苯唑西林: {
                ResistantResult: '未做'
              },
              头孢西丁: {
                ResistantResult: '未做'
              }
            },
            屎肠球菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              氨苄西林: {
                ResistantResult: '未做'
              },
              万古霉素: {
                ResistantResult: '未做'
              }
            },
            粪肠球菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              氨苄西林: {
                ResistantResult: '未做'
              },
              万古霉素: {
                ResistantResult: '未做'
              }
            },
            肺炎链球菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              青霉素: {
                ResistantResult: '未做'
              }
            },
            大肠埃希菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              亚胺_美罗培南: {
                ResistantResult: '未做'
              },
              头孢他啶: {
                ResistantResult: '未做'
              },
              左氧氟沙星: {
                ResistantResult: '未做'
              }
            },
            肺炎克雷伯菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              亚胺_美罗培南: {
                ResistantResult: '未做'
              },
              头孢他啶: {
                ResistantResult: '未做'
              },
              左氧氟沙星: {
                ResistantResult: '未做'
              }
            },
            铜绿假单胞菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              阿米卡星: {
                ResistantResult: '未做'
              },
              环丙沙星: {
                ResistantResult: '未做'
              },
              哌拉西林_他唑巴坦: {
                ResistantResult: '未做'
              },
              头孢吡肟: {
                ResistantResult: '未做'
              },
              头孢他啶: {
                ResistantResult: '未做'
              },
              亚胺培南: {
                ResistantResult: '未做'
              }
            },
            鲍曼不动杆菌: {
              感染状态: {
                ResistantResult: '未做'
              },
              头孢哌酮_舒巴坦: {
                ResistantResult: '未做'
              },
              亚胺培南_美罗培南: {
                ResistantResult: '未做'
              }
            },
            艰难梭菌: {
              感染状态: {
                ResistantResult: '未做'
              }
            },
          }
          this.UseAntibacterialDrug = {
            DrugTreatmentInCultivation: '',
            DrugTreatmentInCultivationBegin: '',
            IsUp: '',
            IsUse: '',
            OtherReason: '',
            UNIONUse: '',
            UpReason: '',
            UsePurpose: '',
          }
          this.InHospitalDate = ''
          this.InvestigateUser = ''
          this.InvestigateDate = ''
          if (!done) {
            this.addDrawer = done
            this.addDept = done
          } else {
            done();
          }
        })
        .catch(_ => { });
    },
    checkVideo() {
      window.open('http://www.scyokj.com:8085/#/video')
    }
  },
};
</script>
<style scoped>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.header {
  margin-top: 15px;
}

.header .first {
  margin-top: 30px;
  font-size: 14px;
}

.red {
  color: red;
}

.orange {
  color: orange;
}

.green {
  color: green;
}

.content {
  width: 90%;
  margin: 50px 5%;
}

.bottom {
  margin: 100px 0 0 100px;
  display: flex;
}

.image {
  height: 200px;
}

.upload-demo {
  margin: 90px 0 0 0;
}

.alltext {
  font-size: 14px;
}

.text {
  font-size: 14px;
}

.texthos {
  color: black;
}

.btnClass {
  height: 40px;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background-color: #ffa8a8;
  color: red;
}

.bg-purple {
  background-color: #ffa8a8;
  color: red;
}

.bg-purple-light {
  background-color: #ffa8a8;
  color: red;
}

.grid-content {
  border-radius: 4px;
  height: 36px;
  line-height: 36px;
  text-align: center;
}

.row-bg {
  padding: 10px 0;
  background-color: #ffa8a8;
  color: red;
}

.green-bg {
  background-color: #67c23a;
  color: #ffffff;
}

.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.body {
  margin-left: 300px;
}

.footer {
  height: 200px;
  margin-top: 50px;
  margin-left: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/prevalence.vue